import React from 'react'
import { Lazyload } from '~/components'
import * as st from '~/assets/styl/DVert.module.styl'
import bg from '~/assets/img/D-Vert.jpg'

export default function DVert() {
  return (
    <Lazyload src={bg} type="section" className={st.core} id="DVert">
      <div></div>
    </Lazyload>
  )
}
